export default {
    init() {
      console.log('download');

      const productBlocks = document.querySelectorAll('.download_page-product-container');

      const productWrappers = document.querySelectorAll('.download_page-product-wrapper')
      function cleanProducts() {
        for(const product of productBlocks){
          product.classList.remove('active')
        }
      }
      
      function cleanWrappers(){
        for(const wrapper of productWrappers){
          wrapper.classList.remove('wrap')
        }
      }
      productBlocks.forEach(product => {
        product.addEventListener('click', () => {
          const blockContainer = product.parentNode
          // console.log(blockContainer)
          cleanWrappers()
          blockContainer.classList.add('wrap')
          cleanProducts()
          console.log(product)
          product.classList.add('active')
        })
        
      });

      /* get the anchor and active the related product */
      const url = window.location.href;
      const anchor = url.split('#')[1];
      if(anchor){
        console.log(anchor)
        const product = document.querySelector(`[data-product-slug="${anchor}"]`)
        if(product){
          for(const wrapper of productWrappers){
            wrapper.classList.add('wrap')
          }
          product.classList.add('active')
        }

        const bodyRect = document.body.getBoundingClientRect(),
        elemRect = product.getBoundingClientRect(),
        offset   = elemRect.top - bodyRect.top;

        window.scrollTo(0, offset - 300);
      }
      
      
    },
    finalize() {
      // JavaScript to be fired on the faq page, after the init JS
    },
  };
  